module.exports = __webpack_public_path__ + "assets/calendar-84ad3964b7cc37397f48648cb2030a82.svg";